/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ApiInputs */

const en_mk_foot_api = /** @type {(inputs: Mk_Foot_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API & agent contract`)
};

const id_mk_foot_api = /** @type {(inputs: Mk_Foot_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrak API & agent`)
};

/**
* | output |
* | --- |
* | "API & agent contract" |
*
* @param {Mk_Foot_ApiInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_api = /** @type {((inputs?: Mk_Foot_ApiInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ApiInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_api(inputs)
	return en_mk_foot_api(inputs)
});